import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ButtonComp from "./ButtonComp";
import BlackCard from "./Card";
import { Link } from "react-router-dom";
import Typography from "./Typography/Typography";
import GAlign from "./GAlign";
import Animation from "../animations/Animation";

export default function WhatMakesUsDifferent(props) {
   return (
      <div>
         <Container
            fluid
            className="d-flex align-items-center pt50 pb50 mobPt10 mobPb10"
            style={{
               background: "#0E0E0E",
            }}>
            <Container>
               <Row className="d-flex align-items-center my-5">
                  <Col xs={12} sm={6} md={8} lg={9} xl={8}>
                     <div>
                        <Animation slide bottom>
                           <Typography element="span" className="red-bar text-white fs18" syne>
                              why choose us
                           </Typography>
                           <Typography element="h3" className="fs60 mobHeadingFontSize tabHeadingFontSize text-white mobMt20" fontWeight={600} syne>
                              What Makes Us Different?
                           </Typography>
                        </Animation>
                     </div>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={3} xl={4}>
                     <Animation slide bottom>
                        <GAlign align="right" className="py-4 mobMt20">
                           <Link to="/get-in-touch">
                              <ButtonComp isDefaultWhite title="GET IN TOUCH" />
                           </Link>
                        </GAlign>
                     </Animation>
                  </Col>
               </Row>
               <Row className="d-flex align-items-center  my-5">
                  <Col xs={12}>
                     <Row>
                        {props.data.map((data, idx) => (
                           <Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={3} className="p-2" key={`service-different-${idx}`}>
                              <Animation slide bottom>
                                 <BlackCard data={data} background="white" color="black" height={props.height} />
                              </Animation>
                           </Col>
                        ))}
                     </Row>
                  </Col>
               </Row>
            </Container>
         </Container>
      </div>
   );
}
